import { BaseObject } from "../../core/BaseObject";
import { LaboratoryRequestIndicatorDto } from "../../laboratory/laboratory-request-indicator.dto";

export class RequestWaterSampling extends BaseObject {
    requestWaterSamplingId: number;
    requestId: number;
    laboratoryExaminationObjectId: number;
    laboratoryExaminationObjectDescription: string;
    manufactureDate: Date;
    supplier: string;
    partNumber: string;
    laboratoryMaterialSourceId: number;
    laboratoryMaterialSourceDescription: string;
    laboratorySamplingPointId: number;
    laboratorySamplingPointDescription: string;
    laboratoryExaminationTypeId: number;
    laboratoryExaminationTargetId: number;
    laboratoryExaminationTargetDescription: string;
    laboratoryCertificateRequiringId: number;
    laboratoryResultDeliveryTypeId: number;
    laboratoryRecommendationId: number;
    approved: boolean;

    requestIndicators: LaboratoryRequestIndicatorDto[] = [];
}